export default __webpack_public_path__ + "static/PROMS-399fc47cff9b7d683fe802ab6e5cbb03.png";